import React from 'react';
import { motion } from 'framer-motion';

const PartnerCard = ({ name, logo, description, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true, margin: "-100px" }}
      className="glass-card p-6 hover:shadow-lg transition-all duration-300 group"
      whileHover={{ 
        y: -5,
        boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
      }}
    >
      <div className="flex flex-col items-center text-center">
        <div className="w-24 h-24 mb-4 flex items-center justify-center bg-dark-100 rounded-full p-4 glow-border">
          <img 
            src={logo} 
            alt={name} 
            className="max-w-full max-h-full filter brightness-0 invert opacity-80 group-hover:opacity-100 transition-all duration-300"
          />
        </div>
        <h3 className="text-xl font-semibold mb-2 text-white group-hover:text-primary-500 transition-colors duration-300">{name}</h3>
        <p className="text-gray-400 group-hover:text-gray-300 transition-colors duration-300">{description}</p>
      </div>
    </motion.div>
  );
}

export default PartnerCard;
